import { render, staticRenderFns } from "./showset.vue?vue&type=template&id=dc1c698e&scoped=true&"
import script from "./showset.vue?vue&type=script&lang=js&"
export * from "./showset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1c698e",
  null
  
)

export default component.exports